import _defineProperty from "@babel/runtime/helpers/defineProperty";
export function getCookiePersistenceDomain() {
  var cookiePersistenceDomain = COOKIE_DOMAIN;
  return cookiePersistenceDomain;
}
class NamespacedLocalStorage {
  constructor(localStorage, key) {
    this.localStorage = localStorage;
    this.key = key;
  }
  _makeKey(key) {
    return "".concat(this.key, "__").concat(key);
  }
  getItem(name) {
    return this.localStorage.getItem(this._makeKey(name));
  }
  setItem(name, value) {
    return this.localStorage.setItem(this._makeKey(name), value);
  }
  removeItem(name) {
    return this.localStorage.removeItem(this._makeKey(name));
  }
}
export default class BrowserPersistence {
  constructor() {
    var localStorage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.localStorage;
    this.originalValueKeys = ["cartId"];
    this.key = this.constructor.KEY || BrowserPersistence.KEY;
    this.storage = new NamespacedLocalStorage(localStorage, this.constructor.KEY || BrowserPersistence.KEY);
  }
  _makeKey(key) {
    return "".concat(this.key, "__").concat(key);
  }
  getItem(name) {
    var now = Date.now();
    var item = this.storage.getItem(name);
    if (!item) {
      return undefined;
    }
    var {
      value,
      ttl,
      timeStored,
      domainSource
    } = JSON.parse(item);
    if (ttl && now - timeStored > ttl * 1000) {
      this.storage.removeItem(name);
      return undefined;
    }
    return value ? value : null;
  }
  setItem(name, value, ttl) {
    var timeStored = Date.now();
    this.storage.setItem(name, JSON.stringify({
      value,
      timeStored,
      ttl
    }));
  }
  removeItem(name) {
    this.storage.removeItem(name);
  }
}
_defineProperty(BrowserPersistence, "KEY", "M2_VENIA_BROWSER_PERSISTENCE");